import Axios from "axios";
import dayjs from "dayjs";
import React from "react";
import { DataTable } from "../data-table";
import { Spin } from "../loading";
import { Pagniation } from "../pagination";

interface DateDataTableProps {
  title: string;
  subtitle: string;
  region: "ntw" | "nte" | "hki";
  path: string;
}

const getMin = (region: "ntw" | "nte" | "hki") => {
  switch (region) {
    case "nte":
      return "2017-10";
    case "hki":
      return "2018-10";
    case "ntw":
      return "2019-10";
  }
};

interface State {
  date: string;
  prevDate: string;
  inspNo: string;
  data: any[];
  loading: boolean;

  paginate: {
    currentPage: number;
    total: number;
    take: number;
  };
}

const take = 10;

const initialState: State = {
  date: dayjs().subtract(2, "month").format("YYYY-MM"),
  prevDate: dayjs().subtract(2, "month").format("YYYY-MM"),
  inspNo: "",
  data: [] as any[],
  loading: false,
  paginate: {
    currentPage: 1,
    take,
    total: Infinity,
  },
};

export const InspectionPage: React.FC<DateDataTableProps> = (props) => {
  const { title, subtitle, region, path } = props;

  const [state, setState] = React.useState<State>(initialState);
  const [allData, setAllData] = React.useState<any[]>([]);

  React.useEffect(() => {
    fetch();
  // eslint-disable-next-line
  }, [state.date, state.inspNo, state.paginate]);

  const fetch = () => {
    const isNotMonth = state.prevDate === state.date;
    const isLoading = state.loading;
    const { date, inspNo, paginate } = state;

    if (!isLoading || !isNotMonth) {
      setState((prev) => ({ ...prev, loading: true }));
      Axios.get<[[], number]>(`/${path.toLowerCase()}`, {
        params: {
          date,
          INSP_NO: inspNo,
          skip: (paginate.currentPage - 1) * paginate.take,
          take: paginate.take,
        },
      })
        .then((res) => {
          const [data, total] = res.data;

          const { paginate } = state;
          setState((prev) => ({
            ...prev,
            data,
            paginate: {
              ...paginate,
              total,
              take,
            },
            prevDate: prev.date,
          }));
        })
        .finally(() => {
          setState((prev) => ({ ...prev, loading: false }));
        });

      Axios.get<[[], number]>(`/${path.toLowerCase()}`, {
        params: {
          date,
          INSP_NO: inspNo
        },
      })
        .then((res) => {
          const [data, total] = res.data;
          setAllData(data);
        })
    }
  };

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;

    setState((prev) => ({
      ...prev,
      prevDate: prev.date,
      inspNo: "",
      date: value,
      paginate: { ...initialState.paginate },
    }));
  };

  const handleSearchBarChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;

    setState((prev) => ({
      ...prev,
      inspNo: value,
      paginate: { ...initialState.paginate },
    }));
  };

  const onChange = (page: number, pageSize: number) => {
    setState((prev) => ({
      ...prev,
      paginate: {
        ...prev.paginate,
        currentPage: page,
        take: pageSize,
      },
    }));
  };

  return (
    <div className="date-datatable">
      <div className="top">
        <span className="title">{title}</span>
        <span className="subtitle">{subtitle}</span>
        <input
          type="month"
          min={getMin(region)}
          value={state.date}
          onChange={handleDateChange}
        />
        <input
          type="text"
          placeholder="INSP_NO"
          style={{height: 24, marginLeft : 5}}
          value={state.inspNo}
          onChange={handleSearchBarChange}
        />
      </div>
      <div className="bottom">
        <Spin spin={state.loading}>
          {state.data.length > 0 && (
            <>
              <DataTable
                columns={Object.keys(state.data[0]).map((key) => ({
                  title: key,
                  dataIndex: key,
                }))}
                data={state.data}
                allData={allData}
              />
              <Pagniation onChange={onChange} {...state.paginate} />
            </>
          )}
        </Spin>
      </div>
    </div>
  );
};
